import { z } from "zod";

import { ProjectsLocationsData } from "../../../../../../models/ProjectData";

export const schema = z.object({
  customNotes: z.string().optional(),
});

export type Schema = z.infer<typeof schema>;

export const generateDefaultValues = (
  projectLocation?: ProjectsLocationsData,
): Schema => {
  return {
    customNotes: projectLocation?.custom_notes ?? "",
  };
};
